/* eslint-disable */
import React, { useEffect, useState ,useContext} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './dealDetailedView.module.scss';
import Button from '../../../../Assets/images/svg/black_back_button.svg';
import CaretDown from '../../../../Assets/images/svg/dar_caret_down.svg';
import DateTime from '../../../../Assets/images/svg/dar_date_time.svg';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { DEAL_TRANSITION_DETAILS_VIEW, FILE_UPLOAD } from '../../../../Constants/strings';
import HDFCERGO from '../../../../Assets/images/svg/dar_hdfc_ergo.svg';
import Edit from '../../../../Assets/images/svg/dar_edit.svg';
import { Divider } from '@mui/material';
import Duration from '../../../../Assets/images/svg/dar_duration.svg';
import FlutterFlow from '../../../../Assets/images/svg/dar_flutter_flow.svg';
import NodeJS from '../../../../Assets/images/svg/dar_node_js.svg';
import DealProgress from './DealProgress/dealProgress'
import UseAxios from '../../../../Api/http/http';
import Breakdown from '../Efforts/Summary/breakdown';
import { getDealDetailViewDetails } from '../../../../Api/request/dealDetailView';
import { AuthContext } from '../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../Constants/modules';
import DOCUMENT_ICON from '../../../../Assets/images/svg/dar_document_icon.svg';
import DOWNLOAD_ICON from '../../../../Assets/images/svg/dar_download.svg';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';
const DealDetailsView = () => {
  const data2 = [];

  const data3 = [
    { name: 'On contract sign', value: '20%' },
    { name: 'On milestone 1', value: '20%' },
    { name: 'On contract sign', value: '20%' },
    { name: 'On milestone 1', value: '20%' },
    { name: 'On Go Live', value: '20%' },
  ];

  const data5 = [
    { signatureId: 1, signatureName: 'Shashir', designation: 'Chief Growth Officer', signatureText: 'Signature for Niveus', status: 'pending' },
    { signatureId: 2, signatureName: 'Jamel Mickel', designation: 'CEO', signatureText: 'Signature for Customer', status: 'pending' },
    { signatureId: 3, signatureName: 'Suyog', designation: 'CEO', signatureText: 'Signature for Niveus', status: 'pending' },
    { signatureId: 4, signatureName: 'Jamel Mickel 2', designation: 'CEO', signatureText: 'Signature for Customer', status: 'pending' },
  ];

  const { userProfile } = useContext(AuthContext);
  const [expandedItems, setExpandedItems] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const [dealName, setDealName] = useState('');
  const [dealSummaryData, setDealSummaryData] = useState([]);
  const [dealAdditionalDetails, setDealAdditionalDetails] = useState([]);
  const navigate = useNavigate();
  
  const isProgressEnabled = false;
  const isSignatureEnabled = false;

  const usePermissions = (moduleName) => {
    return userProfile?.permissions ? userProfile.permissions[moduleName] || [] : [];
  };

  const effortEstimationPermissions = usePermissions(MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION);
  const commercialsPermissions = usePermissions(MODULE_NAMES.DEAL_TRANSITION_DETAIL_COMMERCIALS);

  const hasEffortEstimationAccess = (action) => effortEstimationPermissions.includes(action);
  const hasCommercialAccess = (action) => commercialsPermissions.includes(action);

  const isFinancialEnabled  = hasCommercialAccess('read');  

  const navigateBack = () => {
    navigate('/deal-transition/dashboard');
  };

  const getUrlParameter = (value) => {
    if (typeof window !== "undefined") {
      let queryString = window.location.search;
      let parts = queryString.split("?");
      const urlParams = new URLSearchParams(parts[1]);
      return urlParams.get(value);
    } else {
      return null;
    }
  };
 const { snackbarOpen } = useSnackbar();

  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } else {
      return '';
    }
  };
  

  const formatDealSummary = (deal) => [
    { name: 'Deal name', value: deal?.deal_name ?? ' -' },
    { name: 'Deal value', value: deal?.deal_value ?? '-' },
    {
      name: 'Due date',
      value: deal?.deal_closed_date
        ? new Date(deal.deal_closed_date).toLocaleDateString()
        : '-',
    },
    { name: 'Vertical', value: deal?.deal_vertical ?? '-' },
    { name: 'Status', value: deal?.deal_status_name ?? '-' },
    {
      name: 'Assignee',
      value: ' -', 
    },
    { name: 'Last updated by', value: ' -' }, 
    {
      name: 'Due',
      value: ' -', 
    },
  ];
  
const getFormattedField = (dealAdditionalDetailData, key, customKey) => {
  if (dealAdditionalDetailData?.[key]?.includes("Other")) {
    return dealAdditionalDetailData?.[customKey] ?? '-';
  }
  return dealAdditionalDetailData?.[key]?.join(', ') ?? '-';
};


const getArrayFormattedField = (dealAdditionalDetailData, key, customKey) => {
  if (Array.isArray(dealAdditionalDetailData?.[key])) {
    if (dealAdditionalDetailData[key].includes("Other")) {
      return [
        ...dealAdditionalDetailData[key].filter((name) => name !== "Other"),
        dealAdditionalDetailData?.[customKey] ?? '-'
      ].join(', ');
    }
    return dealAdditionalDetailData[key].join(', ');
  }
  return '-';
};


const getFormattedValue = (data, key, formatter = (x) => x ?? '-') => formatter(data[key]); 


const getCommaSeparatedValues = (data, key) => {
  return data[key] && Array.isArray(data[key]) && data[key].length > 0
    ? data[key].join(', ')
    : '-';
};


const formatAdditionalDetails = (dealAdditionalDetailData) => {
  return [
    {
      name: 'Customer name',
      value: getFormattedValue(dealAdditionalDetailData, 'customer_name'),
    },
    {
      name: 'Customer website',
      value: getFormattedValue(dealAdditionalDetailData, 'customer_website'),
    },
    {
      name: 'Hubspot deal link',
      value: getFormattedValue(dealAdditionalDetailData, 'hubspot_deal_link'),
    },
    {
      name: 'Deal type',
      value: getFormattedField(dealAdditionalDetailData, 'deal_type_id_names', 'deal_custom_type'),
    },    
    {
      name: 'Project overview',
      value: getFormattedValue(dealAdditionalDetailData, 'project_overview'),
    },
    {
      name: 'Problem statement',
      value: getFormattedValue(dealAdditionalDetailData, 'problem_statement'),
    },
    {
      name: 'Type of implementation',
      value: getFormattedField(dealAdditionalDetailData, 'implementation_id_names', 'implementation_custom_data'),
    },
    {
      name: 'Source environment',
      value: getFormattedField(dealAdditionalDetailData, 'environment_id_names', 'environment_custom_data'),
    },
    {
      name: 'Domain / Sector',
      value: getFormattedField(dealAdditionalDetailData, 'sector_id_names', 'sector_custom_data'),
    },
    {
      name: 'Deal vertical',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'vertical_id_names'),
    },
    {
      name: 'Leading vertical',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'leading_id_names'),
    },
    
    {
      name: 'Cross vertical deal?',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'cross_vertical_id_names'),
    },
    {
      name: 'Offering app',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'offering_by_vertical_id_names'),
    },
    {
      name: 'Project type',
      value: getFormattedField(dealAdditionalDetailData, 'project_type_id_names', 'project_type_custom_data'),
    },
    {
      name: 'What kind of deal',
      value: getArrayFormattedField(dealAdditionalDetailData, 'kind_id_names', 'kind_custom_data'),
    },
    {
      name: 'Offering data',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'offering_data_mod_id_names'),
    },
    {
      name: 'Type of workload',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'workload_type_id_names'),
    },
    {
      name: 'Is this a cross vertical deal with Infra included?',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'infra_included_id_names'),
    },
    {
      name: 'Offerings infra',
      value: dealAdditionalDetailData?.offering_infra_mod_id_names?.includes("Other")
        ? dealAdditionalDetailData?.offering_infra_mod_custom_data ?? '-'
        : getCommaSeparatedValues(dealAdditionalDetailData, 'offering_infra_mod_id_names'),
    },
    
    {
      name: 'Select the Infrastructure Opportunity',
      value: dealAdditionalDetailData?.infrastructure_id_names?.includes("Other")
        ? dealAdditionalDetailData?.infrastructure_custom_data ?? '-'
        : getCommaSeparatedValues(dealAdditionalDetailData, 'infrastructure_id_names'),
    },
    {
      name: 'Customer decision maker Email ID',
      value: getFormattedValue(dealAdditionalDetailData, 'customer_decision_email_id'),
    },
    {
      name: 'Customer influencer Email ID',
      value: getFormattedValue(dealAdditionalDetailData, 'customer_influencer_email_id'),
    },
    {
      name: 'Google source deal?',
      value: getCommaSeparatedValues(dealAdditionalDetailData, 'google_source_id_names'),
    },
    {
      name: 'Google FSR and CE names',
      value: getFormattedValue(dealAdditionalDetailData, 'google_fsr_ce_name'),
    },
    {
      name: 'Google CE email ID',
      value: getFormattedValue(dealAdditionalDetailData, 'google_ce_email_id'),
    },
    {
      name: 'Funding source',
      value: getArrayFormattedField(dealAdditionalDetailData, 'funding_source_id_names', 'funding_source_custom_data'),
    },
    {
      name: 'Deal size (USD $) (others - one-time)',
      value: getFormattedValue(dealAdditionalDetailData, 'deal_size'),
    },
    {
      name: 'Engagement model',
      value: getArrayFormattedField(dealAdditionalDetailData, 'engagement_type_id_names', 'engagement_type_custom_data'),
    },
    {
      name: 'NDA signed',
      value: getFormattedValue(dealAdditionalDetailData, 'nda_signed_id_names'),
    },
    {
      name: 'Cost comparison Sheet',
      value: dealAdditionalDetailData?.cost_comparision_file
        ? Object.values(dealAdditionalDetailData.cost_comparision_file).join(', ')
        : '-',
    },
    {
      name: 'Expected date for kickoff',
      value: dealAdditionalDetailData?.expected_kickoff_date
        ? formatDate(dealAdditionalDetailData.expected_kickoff_date)
        : '-',
    },
    {
      name: 'Expected first call with the customer?',
      value: dealAdditionalDetailData?.expected_first_call
        ? formatDate(dealAdditionalDetailData.expected_first_call)
        : '-',
    },
    {
      name: 'Deal Constraints',
      value: getArrayFormattedField(dealAdditionalDetailData, 'deal_constraints_id_names', 'deal_constraints_custom_data'),
    },
    {
      name: 'Details on the constraints',
      value: getFormattedValue(dealAdditionalDetailData, 'details_on_constraints'),
    },
    {
      name: 'Additional files',
      value: dealAdditionalDetailData?.additional_files &&
        Object.keys(dealAdditionalDetailData.additional_files).length > 0 ? (
          <div>
            {Object.values(dealAdditionalDetailData.additional_files).map((file, index) => {
              const fileName = file.replace(/^deal-transition\/\d+\//, '');
              const signedUrl = dealAdditionalDetailData?.additional_filesURL?.[index]; 

              return (
                <div key={fileName} className={styles['doc-container']}>
                  <img src={DOCUMENT_ICON} alt="Document Icon" width={16} height={16} style={{ marginTop: '5px' }} />

                  <Tooltip title={fileName} arrow>
                    <span className={styles['filename']}>{fileName}</span>
                  </Tooltip>

                  <button
                    className={styles['download-btn']}
                    onClick={() => handleDownload(signedUrl)}
                    aria-label={`Download ${fileName}`}
                  >
                    <img src={DOWNLOAD_ICON} alt="Download Icon" width={16} height={16} />
                  </button>
                </div>);

            })}
          </div>
        ) : (
          '-'
        ),
    }
  ];    
};
const handleDownload = async (fileUrl) => {
  try {
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const fileName = decodeURIComponent(fileUrl.split("/").pop().split("?")[0]);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error("Error downloading the file:", error);
    snackbarOpen(FILE_UPLOAD.DOWNLOAD_FAILURE, "error");
  }
};

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const chunkData = (arr, chunkSize) => {  // Split data into chunks of 4 columns //start
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };
  const chunks = isMobileView ? chunkData(dealSummaryData, 2) : chunkData(dealSummaryData, 4);
  let numberOfSections = isMobileView ? 1 : 2;
  const sectionSize = Math.ceil(dealAdditionalDetails.length / numberOfSections);
  const sections = Array.from({ length: numberOfSections }, (_, i) =>
    dealAdditionalDetails.slice(i * sectionSize, (i + 1) * sectionSize)
  );   //end
  
  const handleToggleExpand = (sectionIndex, itemIndex) => {
    setExpandedItems((prev) => ({
      ...prev,
      [`${sectionIndex}-${itemIndex}`]: !prev[`${sectionIndex}-${itemIndex}`],
    }));
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));
  const dealId = getUrlParameter('id');
  useEffect(() => {
    window.scrollTo(0, 0);
    checkMobileView();
    if (!dealId) {
      return;
    }
    const fetchDealDetails = async () => {
      try {
        const response = await UseAxios(getDealDetailViewDetails(dealId));
        const dealAdditionalDetailData = response?.data?.data?.existingDeal;
        const dealSummaryData = dealAdditionalDetailData?.deal;
        if (dealSummaryData) {
        const dealName = dealSummaryData.deal_name;
        setDealName(dealName);
         setDealSummaryData(formatDealSummary(dealSummaryData));
          if (dealAdditionalDetailData) {
            setDealAdditionalDetails(formatAdditionalDetails(dealAdditionalDetailData));
          } 
        }
      } catch (error) {
        console.error('Error fetching deal details:', error);
      }
    };
    fetchDealDetails();
  },[dealId]);

  const navigateToEfforts = () => {
    navigate('/deal-transition/dashboard/efforts?id='+dealId);
  }

  const navigateToFinancials =() =>{
    navigate('/deal-transition/dashboard/financials?id='+dealId);
  }

  return (
    <div className="users-manage-outer-layer" style={{ display: 'flex' }}>
      <div className="users-manage">
        <div className={styles['dealDetailsView-manage-title']}>
          <button className={styles['dealDetailsView-dealExpand-button'] + " back-button-icon"} onClick={() => navigateBack()} aria-label="navigate back">
            <img src={Button} alt="navigate back" />
          </button>
          <div className={styles['dealDetailsView-header']}>{dealName}</div></div>
        <div className={styles['dealDetailsView-splitScreenMain']}>
          <div className={styles['dealDetailsView-splitScreen-flex1']}>
            <div className="users-search-and-buttons" style={{ padding: '16px 24px' }}>
              <div className={styles['dealDetailsView-grid']}>
                <div className={styles['dealDetailsView-dealSummary-header']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_SUMMARY}</div>
                {dealSummaryData && dealSummaryData.length > 0 ? (
                  chunks.map((chunk, rowIndex) => (
                    <div key={`${chunk[0].name}-${rowIndex}`} className={styles['dealDetailsView-dealSummary-rowMain']}>
                      {chunk.map((item, colIndex) => (
                        <div key={`${item.name}-${colIndex}`} className={styles['dealDetailsView-dealSummary-columnMain']}>
                          <div className={styles['dealDetailsView-dealSummary-sectionMain']}>
                            <div className={styles['dealDetailsView-dealSummary-Name']}>{item.name}</div>
                            <div className={styles['dealDetailsView-dealSummary-valueMain']}>
                              {item.name === 'Status' ? (
                                <select disabled className={`${styles['dealDetailsView-dealSummary-value']} ${styles['dealDetailsView-dealSummary-dropdown']}`}  >
                                  <option value={item.value}>{item.value}</option>
                                  <option value="Approved">Approved</option>
                                  <option value="Rejected">Rejected</option>
                                </select>
                              ) : (
                                <div className={styles['dealDetailsView-dealSummary-value']}>{item.value}</div>
                              )}
                              {item.dateTime ? (
                                <HtmlTooltip
                                  title={
                                    <div color="inherit">{item.dateTime}</div>
                                  }
                                >
                                  <img src={DateTime} alt="date and time" className={styles['dealDetailsView-dealSummary-dateTimeImage']} />
                                </HtmlTooltip>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <div className={styles['dealDetailsView-noDataMessage']}>
                    No existing deal found
                  </div>
                )}
              </div>
            </div>
            {isProgressEnabled && (
            <div className={styles['dealDetailsView-splitScreen-dealProgressMobile']}><DealProgress /></div>
          )}
            <div className={styles['dealDetailsView-dealAdditional-main']}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  sx={{ color: '#49454E', fontSize: '16px', fontWeight: '600' }}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  {DEAL_TRANSITION_DETAILS_VIEW.DEAL_ADDITIONAL_DETAILS}
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                  <div className={styles['dealDetailsView-dealAdditional-Section']}>
                    {sections.map((section, sectionIndex) => (
                      <div key={`${section.length}-${sectionIndex}`} className={styles['dealDetailsView-dealAdditional-newSection']}>
                        {section.map((item, itemIndex) => {
                          const isExpanded = expandedItems[`${sectionIndex}-${itemIndex}`];
                          const buttonIconClass = `${styles['dealDetailsView-back-button-icon']} ${isExpanded ? styles['rotated'] : ''}`;
                          return (
                            <div className={styles['dealDetailsView-dealAdditional-newSection-row']} key={`${item.name}-${itemIndex}`}>
                              <div className={styles['dealDetailsView-dealAdditional-newSection-name']}>{item.name}</div>
                              {item.value && item.value.length > 40 ? (
                                <div className={styles['dealDetailsView-dealAdditional-newSection-value']}>
                                  {isExpanded ? item.value : `${item.value.substring(0, 40)}...`}
                                  <button
                                    className={styles['dealDetailsView-dealExpand-button']}
                                    onClick={() => handleToggleExpand(sectionIndex, itemIndex)}
                                  >
                                    <img
                                      src={CaretDown}
                                      className={buttonIconClass}
                                      alt="expand"
                                    />
                                  </button>
                                </div>
                              ) : (
                                <div className={styles['dealDetailsView-dealAdditional-newSection-value']}>{item.value}</div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className={styles['dealDetailsView-dealEfforts-main']}>
              <div className={styles['dealDetailsView-dealEfforts-secondMain']}>
                <div className={styles['dealDetailsView-dealEfforts-header']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_EFFORTS}</div>
                <div className={styles['dealDetailsView-dealEfforts-estimationLink-div']}>
                  {data2.length > 0 ? (
                   <button 
                   onClick={() => navigateToEfforts()}  
                   className={`${styles['dealDetailsView-dealEfforts-estimationLink']} 
                               ${!hasEffortEstimationAccess('read') ? styles.disabledButton : ''}`} 
                   disabled={!hasEffortEstimationAccess('read')}
                 >
                   {DEAL_TRANSITION_DETAILS_VIEW.DEAL_ESTIMATION_LINK}
                 </button>
                 
                  ) : (
                    <button 
                    onClick={() => navigateToEfforts()} 
                    className={`${styles['dealDetailsView-dealEfforts-estimationLink']} 
                                ${!hasEffortEstimationAccess('create') ? styles.disabledButton : ''}`} 
                    disabled={!hasEffortEstimationAccess('create')}
                  >
                    Add effort details
                  </button>
                  
                  )}
                </div>
              </div>
              {hasEffortEstimationAccess('read') && data2.length > 0 ? (
                <div style={{ backgroundColor: '#E3F4FF', borderRadius: 4, padding: 12, marginTop: 16 }}>
                  <div className={styles['dealDetailsView-top-container-1']}>
                    <div className={styles['dealDetailsView-logo-project-name']}>
                      <div className={styles['dealDetailsView-logo']}>
                        <img src={HDFCERGO} alt="HDFC ERGO" />
                      </div>
                      <div className={styles['dealDetailsView-name-effort']}>
                        <div className={styles['dealDetailsView-name']}>HDFC ERGO</div>
                        <div className={styles['dealDetailsView-efforts']}>
                          <img src={Duration} alt="Duration" style={{ marginRight: 6 }} /> 1500 Man Days
                        </div>
                      </div>
                    </div>
                    <div className={styles['dealDetailsView-tech-stack-container']}>
                      <div className={styles['dealDetailsView-text']}>Techstack</div>
                      <div className={styles['dealDetailsView-tech-stack-list']}>
                        <div className={styles['dealDetailsView-tech-stack']}>
                          <img src={FlutterFlow} className={styles['dealDetailsView-image']} alt="Flutter Flow" />{' '}
                          FlutterFlow
                        </div>
                        <div className={styles['dealDetailsView-tech-stack']}>
                          <img src={NodeJS} className={styles['dealDetailsView-image']} alt="NodeJS" />{' '}
                          Node JS
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles['dealDetailsView-top-container-2']}>
                    <div className={styles['dealDetailsView-project-duration']}>
                      <div className={styles['dealDetailsView-text']}>Project Duration</div>
                      <div className={styles['dealDetailsView-flex-between']}>
                        <div className={styles['dealDetailsView-denomination']}>
                          6 Months
                          <div className={styles['dealDetailsView-bracket']}>
                            (Estimated from 1st Jan 2025)
                          </div>
                        </div>
                        <div style={{ alignContent: 'end' }}><img src={Edit} alt='edit icon' /></div>
                      </div>
                    </div>
                    <Divider orientation="vertical" flexItem />
                    <div className={styles['dealDetailsView-project-duration']}>
                      <div className={styles['dealDetailsView-text']}>Last Updated</div>
                      <div className={styles['dealDetailsView-flex-between']}>
                        <div className={styles['dealDetailsView-denomination']}>
                          Subhas Prabhu, SA
                          <div className={styles['dealDetailsView-bracket']}>
                            (31 August 2024, 5:30 PM)
                          </div>
                        </div>
                        <div className={styles['dealDetailsView-view-history']}>View History</div>
                      </div>
                    </div>
                  </div>
                  <Breakdown />
                </div>
              ) : null}
            </div>
            <div className={styles['dealDetailsView-dealEfforts-main']}>
              <div className={styles['dealDetailsView-dealEfforts-secondMain']}>
                <div className={styles['dealDetailsView-dealEfforts-header']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_FINANCIAL}</div>
                <button className={`${styles['dealDetailsView-dealEfforts-estimationLink']} ${!isFinancialEnabled ? styles.disabledButton : ''}`}disabled={!isFinancialEnabled} onClick={() => navigateToFinancials()}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_PRICING_TEMP_LINK}</button>
              </div>
              { isFinancialEnabled && (
              <div>
                <div className={styles['dealDetailsView-dealEfforts-boxHeadMain']}>
                  <div className={styles['dealDetailsView-dealFinance-boxHead']}>
                    <div className={styles['dealDetailsView-dealFinance-heading2']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_PAYMENT_TERMS}</div>
                    <div className={styles['dealDetailsView-dealFinance-contentMain']}>
                      <div className={styles['dealDetailsView-dealFinance-contentText1']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_VALUE} <div className={styles['dealDetailsView-dealFinance-contentText2']}>$ 23000</div>|</div>
                      <div className={styles['dealDetailsView-dealFinance-contentText3']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_MARGIN} <div className={styles['dealDetailsView-dealFinance-contentText2']}>20%</div>|</div>
                      <div className={styles['dealDetailsView-dealFinance-contentText3']}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_BILLING_RATE} <div className={styles['dealDetailsView-dealFinance-contentText4']}>70%</div></div>
                    </div>
                  </div>
                  {data3.map((row, index) => (
                    <div key={`${row.name}-${index}`} className={styles['dealDetailsView-dealEfforts-contentMain']}>
                      <div className={styles['dealDetailsView-dealEfforts-contentText1']}>{row.name}</div>
                      <div className={styles['dealDetailsView-dealEfforts-contentText2']}>{row.value}</div>
                    </div>
                  ))}
                </div>
              </div>
              )}
            </div>
            <div className={`${styles['dealDetailsView-dealSignature-termsConditions']} ${!isSignatureEnabled ? styles.disabledButton : ''}`}>{DEAL_TRANSITION_DETAILS_VIEW.DEAL_TERMS_CONDITIONS}</div>
            <div className={styles['dealDetailsView-dealSignature-main']}>
              {isSignatureEnabled && data5.map((item, itemIndex) => {
                if (itemIndex % 2 === 0) {
                  return (
                    <div key={`${item.status}-${itemIndex}`} className={styles['dealDetailsView-dealSignature-contentMain']}>
                      <div className={styles['dealDetailsView-dealSignature-signatureMain1']}>
                        <div className={styles['dealDetailsView-dealSignature-contentStatus']}>({item.status})</div>
                        <div className={styles['dealDetailsView-dealSignature-contentText']}>{item.signatureText}</div>
                        <div className={styles['dealDetailsView-dealSignature-contentName']}>{item.signatureName}, {item.designation}</div>
                      </div>
                      {data5[itemIndex + 1] && (
                        <div className={styles['dealDetailsView-dealSignature-signatureMain2']}>
                          <div className={styles['dealDetailsView-dealSignature-contentStatus']}>({data5[itemIndex + 1].status})</div>
                          <div className={styles['dealDetailsView-dealSignature-contentText']}>{data5[itemIndex + 1].signatureText}</div>
                          <div className={styles['dealDetailsView-dealSignature-contentName']}>{data5[itemIndex + 1].signatureName}, {data5[itemIndex + 1].designation}</div>
                        </div>
                      )}
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </div>
          {isProgressEnabled && (
          <div className={styles['dealDetailsView-splitScreen-flex2']}><DealProgress /></div>
        )}
        </div>
      </div>
    </div>
  );
};

export default DealDetailsView;